module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('article', [_c('heading', {
    attrs: {
      "text": _vm.gallery.title,
      "level": 2,
      "font": "oswald",
      "color": "white"
    }
  }), _vm._v(" "), (_vm.gallery.date) ? _c('div', {
    staticClass: "info"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('galleries.credits')) + " " + _vm._s(_vm.gallery.author))]), _c('br'), _vm._v("\n    " + _vm._s(_vm.$d(new Date(_vm.gallery.date), 'short')) + "\n  ")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.gallery.picture), function(photo) {
    return _c('figure', [_c('img', {
      attrs: {
        "src": photo,
        "alt": _vm.gallery.title
      }
    })])
  }), _vm._v(" "), (_vm.$loading) ? _c('loader') : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e6c5bfca"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/router-views/webzine/PhotoGallery.vue
// module id = 284
// module chunks = 0